export default `
  input, textarea {
    display: block;
    width: 100%;
    border: none;
    padding: 15px;
  }
`